class FilterOrderer {
  constructor() {
    // Filters order defined as global variables
    this.accessoriesOrder = Antonioli.filters.accessories_filter_order;
    this.footwearOrder = Antonioli.filters.footwear_filter_order;
    this.clothingOrder = Antonioli.filters.clothing_filter_order;
  }

  reorderFilters(filterValues, order, key, isSize = false) {

    const splitter = isSize ? '&' : '|'
    const values = [];
    const foundValues = {};

    const sections = order.split(splitter);
      sections.forEach((section, index) => {
        let valueFound = false;
        section.split(',').forEach(orderVal => {
          for (const value of filterValues) {
            if (value[key] === orderVal) {
              foundValues[value[key]] = true;
              values.push(value);
              valueFound = true;
            }
          }
        });
        // valueFound && values.push({ param_name: 'separator' });
      });
    for (const value of filterValues) {
      !foundValues[value[key]] && values.push(value);
    }
    return values;
  }

  createSeparator() {
    const separator = `<li style='grid-column: 1/4; height: 0.1rem; background: black'><p></p></li>`;
    const parser = new DOMParser();
    const parsedHTML = parser.parseFromString(separator, 'text/html');
    return parsedHTML.querySelector('li');
  }

  getOrderStrategy(name) {
    let orderConfig = this.clothingOrder
    
    if (name.includes('size-shoes')) {
      orderConfig = this.footwearOrder
    }
    
    if (name.includes('size-accessories')) {
      orderConfig = this.accessoriesOrder
    }
    if (name.includes('size')) {
      let order;
      const splits = name.split('-');
      const sizeLabel = splits[splits.length - 1].replace('_', '/');
      orderConfig.split('|').forEach(orderGroup => {
        const [label, sizeOrder] = orderGroup.split('=');
        if (label.toLowerCase().startsWith(sizeLabel.toLowerCase()) ) {
          order = sizeOrder;
        }
      });
      return order
    }
  }
}

if (!customElements.get('at-facets-filters')) {
  customElements.define(
    'at-facets-filters',
    class ATFacetsFilters extends HTMLElement {
      constructor() {
        super();
        this.numberOfMacro = false;
        this.type = this.dataset.type ? this.dataset.type : false
        if(this.type) {
          this.renderAllFilters();
        } else {
          this.filterOrderer = new FilterOrderer()
          this.renderFilters();
        }
      }

      renderAllFilters() {
        this.renderMacroCategoryFilters();
        this.renderMicroCategoryFilters();
      }

      renderMicroCategoryFilters() {
        const filters = this.getFilterData();

        if (!filters) return;
        if(this.type == 'micro') {
          // Reset elements
          const children = Array.from(this.childNodes); // Convert NodeList to Array

          children.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                node.remove(); // Remove text node
            }
          });

            let allValues = this.dataset.values

            let childValues = false, values = allValues;

            if(allValues.includes('#')) {
              allValues = allValues.split('#')
              values = allValues[0]
              childValues = allValues[1]
            }

            const parentElem = this.dataset.parent.toLowerCase()
            const categories = values.split(',');
            categories.forEach(elem => {
              
              const [parent, child] = elem.split('_'); // Destructuring assignment
              const parentCategory = parent.toLowerCase().replace('*','')
              const childCategory = child.toLowerCase().replace('*','')

              if(parentElem === parentCategory && parentCategory != childCategory) {

                const content = this.querySelector('template').content.cloneNode(true);
                content.querySelector('summary').appendChild(this.createSummary(childCategory, childValues))

                filters.values.forEach(value => {
                  const parser = new DOMParser;
                  const dom = parser.parseFromString(
                      '<!doctype html><body>' + value.parent,
                      'text/html');
                  const decodedString = dom.body.textContent;
                  if(childCategory == decodedString && childCategory != value.child) {
                    content.querySelector('ul').appendChild(this.createFacet(value));
                  }
                });

                if(content.querySelector('ul').getElementsByTagName('li').length > 0)
                  this.appendChild(document.importNode(content, true));
              }
            })

            // [AT-796] nelle plp di terzo livello lasciare le micro gia esplose.
            document.querySelector(`[data-parent='${parentElem}'] .microcategory`).setAttribute('open', '');
        }
      }

      renderMacroCategoryFilters() {
          const filters = this.getFilterData();

          Antonioli.filterToActivate = filters;


          if(this.type == 'macro') {
            this.numberOfMacro = filters.values.length;
            Antonioli.macrocategoryLength = filters.values.length;
          }

          // Exit early if filters are not available or type is not 'macro'
          if (!filters || this.type !== 'macro') {
              return;
          }

          // Select the <ul> element once and clear its content
          const ulElement = this.querySelector('ul');
          ulElement.innerHTML = ''; // Clear existing content

          // Filter and append matching filter values
          filters.values.forEach(value => {
              const parent = this.dataset.parent;
              if (parent && parent.includes(value.parent)) {
                  const facetElement = this.createFacet(value);
                  ulElement.appendChild(facetElement);
              }
          });
      }

      /**
       * Create a facet element based on the provided filter data.
       *
       * @param {object} filter - The filter data to create the facet for.
       * @return {Element} The created facet element.
       */
      createFacet(filter) {
        
        let clonedFacet;
        if (filter.param_name === 'separator') {
          clonedFacet = `<li class="tw-h-[0.1rem] tw-bg-black tw-w-full"><span class="tw-invisible">divider</span></li>`;
        } else {
        const isDisabled = filter.count == 0 ? 'disabled' : ''
        const isDisabledClass = isDisabled ? 'facet-checkbox--disabled disabled' : ''
        const active = filter.active == 'true' ? 'active' : '';
        const checked = filter.active == 'true' ? 'checked' : '';
        const microToSelectHandle = new StringTransformer(filter.value);
        clonedFacet = `<li class='facets__item tw-flex-col tw-items-start tw-capitalize facets__${filter.param_name}' id='${filter.param_name}-${filter.value}'>
          <label
            class='facets__label tw-group facet-checkbox ${isDisabledClass} ${active}'
            for='Filter-${filter.param_name}-${filter.value}'
          >
            <input
              name='${filter.param_name}'
              type='checkbox'
              ${checked}
              ${isDisabled}
              id='Filter-${filter.param_name}-${filter.value}'
              micro-select='${microToSelectHandle.toHandleize}'
              value='${filter.value}'
            >
            <span class='facet-checkbox__text group-[.active]:tw-border-b tw-link-menu' aria-hidden='true'>
              <span class='value' aria-hidden='true'>${filter.label}</span>
            </span>
          </label>
        </li>`;
        }

        const parser = new DOMParser();
        const parsedHTML = parser.parseFromString(clonedFacet, 'text/html');

        return parsedHTML.querySelector('li');
        
      }

      createSummary(category, categories) {
        let clonedSummary;
        let counter = categories? categories.split(',').length : '';
        clonedSummary = `
          <div class="tw-pointer-events-none">
            <span class="facets__summary-label tw-h3-bol tw-uppercase">
              ${category.toLowerCase()}
                <span class="facets__selected no-js-hidden"></span>
                <sup class="-tw-top-[1rem] tw-font-normal tw-text-[0.8rem] -tw-ml-[0.03rem]">${counter}</sup></span
            >
            </span>
            <svg class="icon icon-caret group-open/details:tw-rotate-180 tw-group/svg" xmlns="http://www.w3.org/2000/svg" width="13.685" height="12.544" viewBox="0 0 13.685 12.544">
              <path id="Poligono_26" class="group-open/details:tw-fill-black group-hover/svg:tw-stroke-2" data-name="Poligono 26" d="M6,0l6,11H0Z" transform="translate(12.842 11.5) rotate(180)" fill="none" stroke="#000" stroke-width="1"/>
            </svg>
          </div>`;

        const parser = new DOMParser();
        const parsedHTML = parser.parseFromString(clonedSummary, 'text/html');

        return parsedHTML.querySelector('div');
      }

      renderFilters() {
        const filter = this.getFilterData();
        if (!filter) return;

        const order = this.filterOrderer.getOrderStrategy(filter.param_name);

        const values = order ? this.filterOrderer.reorderFilters(filter.values, order, 'value', filter.param_name?.includes('size')) : filter.values;

        values.forEach((value, index) => {
          if (value.param_name === 'separator' && index < values.length - 1) {
            this.querySelector('ul').appendChild(this.createFacet(value));
          } else {
            this.querySelector('ul').appendChild(this.createFacet(value));
          } 
        });
      }

      getFilterData() {
        const textContent = this.querySelector('[type="application/json"]')?.textContent;
        if (!textContent) return;
        const filterJson = JSON.parse(textContent)

        // filterJson.values = filterJson.values.filter(value => parseInt(value.count) > 0)
        this.filterData = this.filterData || filterJson;
        return this.filterData;
      }

    }
  );
}
